import React, { useState } from 'react';
import '../styles/Contact.css';

const Contact = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', form);
    // You can integrate with backend or email service here
  };

  return (
    <section className="contact">
      <h2>Contact Us</h2>
      <p className="subtitle">Get in touch with us for admissions, inquiries, or partnership opportunities</p>

      <div className="contact-grid">
        <form className="contact-form" onSubmit={handleSubmit}>
          <h3>Send Us a Message</h3>
          <input type="text" name="name" placeholder="Full Name" value={form.name} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Email Address" value={form.email} onChange={handleChange} required />
          <input type="tel" name="phone" placeholder="Phone Number" value={form.phone} onChange={handleChange} />
          <input type="text" name="subject" placeholder="Subject" value={form.subject} onChange={handleChange} />
          <textarea name="message" placeholder="Message" rows="5" value={form.message} onChange={handleChange} required />
          <button type="submit">Send Message</button>
        </form>

        <div className="contact-info">
          <h3>Get in Touch</h3>
          <p><strong>Visit Us:</strong><br />Om Ganesh Nagar, Vadavalli, Coimbatore, Tamil Nadu 641041</p>
          <p><strong>Call Us:</strong><br />+91 98765 43210</p>
          <p><strong>Office Hours:</strong><br />Mon–Fri: 9:00 AM – 6:00 PM<br />Sat: 10:00 AM – 4:00 PM</p>
          <button className="map-btn">Interactive Map</button>
        </div>
      </div>

      <div className="faq">
        <h3>Frequently Asked Questions</h3>
        <ul>
          <li><strong>What are the admission requirements?</strong><br />Academic transcripts, entrance exams, and a statement of purpose.</li>
          <li><strong>Do you offer financial aid?</strong><br />Yes, scholarships, grants, and payment plans are available.</li>
          <li><strong>Can I take courses online?</strong><br />Yes, most programs offer online and hybrid options.</li>
          <li><strong>How do I apply?</strong><br />Apply online or visit our admissions office for help.</li>
        </ul>
      </div>
    </section>
  );
};

export default Contact;
